var _rect, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMenuSecurityIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "privacy-icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4791",
    "data-name": "Rectangle 4791",
    width: 24,
    height: 24,
    fill: "rgba(255,255,255,0)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icons_Lock_Line",
    "data-name": "icons/Lock/Line",
    transform: "translate(4.985 3.427)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M7.014,1.559c-1.382,0-2.612.05-3.618.114A1.856,1.856,0,0,0,1.641,3.408c-.049.674-.083,1.383-.083,2.047S1.593,6.83,1.641,7.5A1.856,1.856,0,0,0,3.4,9.238c1.005.064,2.236.114,3.618.114s2.612-.05,3.618-.114A1.856,1.856,0,0,0,12.388,7.5c.049-.674.083-1.383.083-2.047s-.034-1.374-.083-2.047a1.856,1.856,0,0,0-1.755-1.735C9.627,1.609,8.4,1.559,7.014,1.559ZM3.3.117A3.415,3.415,0,0,0,.087,3.3C.036,3.993,0,4.743,0,5.456s.036,1.463.087,2.16A3.415,3.415,0,0,0,3.3,10.794c1.034.066,2.3.117,3.717.117s2.683-.052,3.717-.117a3.415,3.415,0,0,0,3.211-3.179c.05-.7.087-1.447.087-2.16s-.036-1.463-.087-2.16A3.415,3.415,0,0,0,10.731.117C9.7.052,8.433,0,7.014,0S4.332.052,3.3.117Z",
    transform: "translate(0 6.235)",
    fill: "#353945",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-2",
    "data-name": "Shape",
    d: "M2.338,2.909a1.559,1.559,0,1,0-1.559,0V3.9a.779.779,0,1,0,1.559,0Z",
    transform: "translate(5.456 9.353)",
    fill: "#353945"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-3",
    "data-name": "Shape",
    d: "M0,3.9a3.9,3.9,0,0,1,7.794,0V7.014a.779.779,0,0,1-1.559,0V3.9a2.338,2.338,0,1,0-4.676,0V7.014A.779.779,0,1,1,0,7.014Z",
    transform: "translate(3.118 0)",
    fill: "#353945"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuSecurityIcon);
export default __webpack_public_path__ + "static/media/menuSecurityIcon.0f9c1c35810edeeea6d0f7ee130632f1.svg";
export { ForwardRef as ReactComponent };